<template>
  <div class="modal-mask" v-show="showModal" transition="modal">
    <div class="modal-container">
      <div class="modal-header">
        <slot name="header">default header</slot>
      </div>

      <div class="modal-body">
        <slot name="body">default body</slot>
      </div>

      <div class="modal-footer">
        <slot name="footer"> default footer </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import { toRef } from "@vue/composition-api";

  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },

    setup(props) {
      const showModal = toRef(props, "show");

      return {
        showModal,
      };
    },
  };
</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }

  .modal-mask {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    width: 100%;
    max-width: 564px;
    padding: 24px;
    margin: 12px;
    background-color: #f4f5fa;
    border-radius: 6px;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 10px 0px rgba(69, 64, 78, 0.1);
    @media screen and (max-width: 767px) {
      padding: 12px;
    }
  }
</style>
